import { ControlBaseModel, ColumnModel, ActionModel } from "./index";
import { IRowDefinition, ITable } from "../abstraction/index";

// Tableau
export class TableModel extends ControlBaseModel {
	colsDef: ColumnModel[] = [];
	Rows: any[] = [];
	selectedRow: IRowDefinition;
	title: string;
	actions: ActionModel[] = [];
	newRows: string;

	public static create(s: ITable): TableModel {
		let it = new TableModel();
		it.Key = s.Code;
		it.Id = s.Id;
		it.title = s.Description;
		it.selectedRow = s.SelectedRow;
		
		s.ColDefs.map(c => {
			it.colsDef.push(ColumnModel.create(c));
		});

		it.Rows = s.Rows;
		it.newRows = s.NewRows;

		s.Actions.map(a => {
			it.actions.push(ActionModel.create(a));
		});

		return it;
	}

	// IStylizable implementation
	Class: string;
	InlineStyle: string;
	InputInlineStyle: string;

	// IVisibility implementation
	Visible: boolean = true;
	bsSize: string;

	// IDisable implementation
	Disable: boolean;

	// IDefaultSort implementation
	DefaultSort: string;

	// Formules conditonelles pour couleur de fond des donn�es
	BgGreenCond: string;
	BgYellowCond: string;
	BgOrangeCond: string;
	BgRedCond: string;

	TabRowDblClick: string = "";	// ID de l'action � �x�cuter en cas de double clic on the line
	TabAction1: string = "";
	TabAction2: string = "";
	NormBarcod: string = "";
	BarCodCond: string = "";
	ValidCond: string = "";
	TabAutoSelectSingleRow: boolean = false;
	TabAutoSelectAction: string;

	TreeViewKeyPath: string = "";		// Binding sur colonne repr�sentant la cl� de la ligne en mode TreeView
	TreeViewParentKeyPath: string = "";  // Binding sur colonne repr�sentant la cl� de la ligne PARENT en mode TreeView
	TreeViewIsExpandedPath: string = "";// Binding sur colonne indiquant si l'arbre est pli� (0) ou ouvert (1)
	TreeViewIconPath: string;
	TreeViewLevelPath: string;

	ShowAsGraph: boolean;
	GraphType: string;
	GraphXPath: string;
	GraphSeries: string;
	GraphSeriesColor:string

	SearchFieldName: string;
	ColType: any;

}
